import { Skeleton } from '@common/components';
import { cn } from '@core/utils';

interface GoodsCardProps {
  className?: string;
}

export const GoodsCardSkeleton = ({ className }: GoodsCardProps) => {
  return (
    <div
      className={cn('flex h-238 w-full flex-col justify-between', className)}
    >
      <Skeleton className="aspect-square size-full rounded-medium" />
      <div className="flex h-42 flex-col justify-center gap-2">
        <Skeleton className="h-16 w-full" />
        <Skeleton className="h-16 w-1/2" />
      </div>
      <Skeleton className="h-18 w-2/3" />
    </div>
  );
};
